import React from "react";
import "./_club-finder-single-result.scss";
import ClubHeader from "../../atoms/club-header/club-header";
import ClubTile from "../../atoms/club-tile/club-tile";
import ClubContactDetails from "../../atoms/club-contact-details/club-contact-details";
import ClubDescription from "../../atoms/club-description/club-description";
import ClubCompetitionTile from "../../atoms/club-competition-tile/club-competition-tile";
import {
  ClubDetailsTypes
} from "../../../types/ApiTypeDefinition/singleClubFinderResultTypes";

interface ClubFinderSingleResultPropType {
  clubFinderSingleResult: ClubDetailsTypes
  buttonActionHandle: any
  backButtonEnabled: boolean
  tenant?: string
}

const ClubFinderSingleResult = (props: ClubFinderSingleResultPropType): JSX.Element => {
  const clubRegistrationForms = props.clubFinderSingleResult ? props.clubFinderSingleResult.registrationForms : null
  const clubProgramList = (clubRegistrationForms && clubRegistrationForms.programRegistrationForms) ? clubRegistrationForms.programRegistrationForms.map((clubCompetition: any, index: number) =>
    <ClubCompetitionTile competitionDetails={clubCompetition} clubLogoVisible={true} key={index}/>
  ) : null;

  const clubCompetitionList = (clubRegistrationForms && clubRegistrationForms.competitionRegistrationForms) ? clubRegistrationForms.competitionRegistrationForms.map((clubCompetition: any, index: number) =>
    <ClubCompetitionTile competitionDetails={clubCompetition} clubLogoVisible={true} key={index}/>
  ) : null;

  return (
    <div className={'clubFinderSingleResultContainer'}>
      <ClubHeader buttonActionHandle={props.buttonActionHandle} backButtonEnabled={props.backButtonEnabled}
                  clubLogo={props.clubFinderSingleResult.orgLogo && props.clubFinderSingleResult.orgLogo ? props.clubFinderSingleResult.orgLogo : ''}
      tenant={props.tenant}/>
      <ClubTile clubDetails={props.clubFinderSingleResult} clubLogoVisible={false}
                clubTileContainerStyles={'clubTileContainerStyles'} index={0}/>
      <div className={'clubDetailsListOverflow'}>
        <ClubContactDetails contactNumber={props.clubFinderSingleResult.contactNumber}
                            mailId={props.clubFinderSingleResult.contactEmail}
                            websiteText={props.clubFinderSingleResult.contactWebsite} tenant={props.tenant}/>
        {((props.clubFinderSingleResult.formats && props.clubFinderSingleResult.formats.length > 0)  || (props.clubFinderSingleResult.description && props.clubFinderSingleResult.description.length > 0)) && (
          <ClubDescription clubFormatObject={props.clubFinderSingleResult.formats}
                           clubDescription={props.clubFinderSingleResult.description}/>
        )}
        {clubRegistrationForms && (clubRegistrationForms.programRegistrationForms && clubRegistrationForms.programRegistrationForms.length > 0) && (
          <div className={'clubFinder-registration-form-heading'}>
            Programs we offer
          </div>
        )}
        {clubProgramList}
        {clubRegistrationForms && (clubRegistrationForms.programRegistrationForms && clubRegistrationForms.programRegistrationForms.length > 0) && (
          <div className={'clubFinderSingleResultContainer-prog-comp-divider'}></div>
        )}
        {clubRegistrationForms && (clubRegistrationForms.competitionRegistrationForms && clubRegistrationForms.competitionRegistrationForms.length > 0) && (
          <div className={'clubFinder-registration-form-heading'}>
            Competitions we offer
          </div>
        )}
        {clubCompetitionList}
      </div>
    </div>
  )
}

export default ClubFinderSingleResult;
